/* eslint-disable import/no-cycle */
/* eslint-disable no-promise-executor-return */
/* eslint-disable unused-imports/no-unused-vars */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { LiveNewsDrawer } from '../LiveNewsDrawer';
import { MedalTally } from './MedalTally';

export const fetchItems = (controller: AbortController) =>
  LiveNewsDrawer.DEBUG
    ? new Promise<typeof MedalTally.SAMPLE_DATA>(resolve => setTimeout(() => resolve(MedalTally.SAMPLE_DATA), 2000))
    : // TODO... Need API
      Promise.resolve([]);
